<template>
  <div class="meta-row">
    <button
      v-if="(!isActiveSoloCarta || isAdmin) && getCartProductQty(food)"
      type="button"
      class="order-button remove-product"
      @click="removeOneFromCart(food)"
    >
      <font-awesome-icon
        icon="minus-square"
        :style="{ color: '#ea2222', fontSize: 20 }"
      />
    </button>

    <button
      v-if="(!isActiveSoloCarta || isAdmin) && isPossitiveWeight && !isOnlyMenu"
      type="button"
      class="order-button add-product"
      @click="addToCart(food)"
    >
      <font-awesome-icon
        icon="plus-square"
        :style="{ color: '#11bd11', fontSize: 20 }"
      />
    </button>

    <span v-if="getCartProductQty(food)" class="cart-quantity"
      >{{ getCartProductQty(food) }}x</span
    >
    <div
      class="product-price"
      :style="{ color: listItemPriceColorTheme, width: priceTagWidth(food) }"
    >
      {{
        formatPrice(food.price) + (food.priceType === "weight" ? ` / Kg` : "")
      }}
    </div>

    <CookingPointsDialog ref="cookingPointsDialog"></CookingPointsDialog>
    <IngredienteDialog ref="ingredienteDialog"></IngredienteDialog>
    <QrValidationModal
      :checkQR="checkQR"
      @closeQrValidationModal="closeQrValidationModal"
      :isAdmin="isAdmin"
    ></QrValidationModal>
    <email-modal ref="emailModalRef"></email-modal>
    <InsertWeightModal ref="insertWeightModalRef" />
  </div>
</template>

<script>
import CookingPointsDialog from "@/components/public/products/SelectItems/CookingPointsDialog";
import IngredienteDialog from "@/components/public/products/SelectItems/IngredienteDialog";
import QrValidationModal from "@/components/public/modals/QrValidationModal";
import EmailModal from "@/components/public/modals/EmailModal.vue";
import InsertWeightModal from "@/components/public/modals/InsertWeightModal.vue";
const NO_QR = "NO QR";

export default {
  name: "add-to-cart-food",
  props: ["food", "isAdmin"],
  components: {
    QrValidationModal,
    CookingPointsDialog,
    IngredienteDialog,
    EmailModal,
    InsertWeightModal
  },
  data() {
    return {
      size: "base",
      checkQR: false
    };
  },
  computed: {
    tableQR() {
      return !this.isAdmin
        ? this.$store.state.tableQR
        : this.$store.state.adminTableQR;
    },
    isPossitiveWeight() {
      return this.food.priceType === "weight"
        ? !this.getCartProductQty(this.food)
        : true;
    },
    getEmail() {
      return this.$store.getters.getEmail(this.isAdmin);
    }
  },
  methods: {
    priceTagWidth(food) {
      return food.priceType === "weight" ? "89px" : "65px";
    },
    getCartProductQty(product) {
      const { cart, admincart } = this.$store.state;
      const order = this.getOrder(product, this.size);
      return this.getCartProductQuantity(
        this.isAdmin ? admincart : cart,
        order
      );
    },
    removeOneFromCart(product) {
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        return;
      }

      const order = this.getFoodOrder(product);
      if (!this.isAdmin) {
        this.$store.commit("removeOneFromCart", {
          product: product,
          order: order,
          update: true
        });
      } else {
        this.$store.commit("removeOneFromCart", {
          product: product,
          order: order,
          update: true,
          cart_type: "admin"
        });
      }
    },
    addToCart(product) {
      let email = this.getEmail;
      if (!email) {
        this.$refs.emailModalRef.open();
        return;
      }
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        return;
      }

      // check cart item length is greater then 20
      const { cart } = this.$store.state;
      const { admincart } = this.$store.state;
      if (cart.length >= 20) {
        this.showErrorMessage(this.$t("cart.theMaximumNumberOfProductAllowed"));
        return;
      }
      if (this.isAdmin && admincart.length >= 20) {
        this.showErrorMessage(this.$t("cart.theMaximumNumberOfProductAllowed"));
        return;
      }

      let item;
      item = {
        price: product.price,
        name: product.name,
        product_id: product.id,
        product_type_id: product.product_type_id,
        category_id: product.category_id,
        quantity: 1,
        size: this.size,
        order: this.getOrder(product, this.size),
        notes: "",
        stripeProduct: null,
        stripeSku: null,
        hasCookingPoints: product.hasCookingPoints || false,
        tableQR: this.tableQR,
        email: email,
        canBeShared: product.canBeShared || false,
        canBeMainCourse: product.canBeMainCourse || false,
        priceType: product.priceType || "unit",
        isAllowComment: product.isAllowComment,
        isPrinted: false,
        isDelivered: false,
        trans: product.trans
          ? product.trans
          : {
              name: {
                en: product.name,
                es: product.name,
                de: product.name,
                fr: product.name,
                it: product.name
              }
            }
      };

      if (product.priceType === "weight") {
        this.$refs.insertWeightModalRef.open(item, this.isAdmin);
        return;
      }

      if (product.hasCookingPoints) {
        this.isAdmin ? (item.cart_type = "admin") : item;
        this.$refs.cookingPointsDialog.open(item);
        return;
      }

      if (
        product.hasMainIngredient &&
        product.ingredients &&
        product.ingredients.length
      ) {
        this.isAdmin ? (item.cart_type = "admin") : item;
        this.$refs.ingredienteDialog.open(
          item,
          product.ingredients,
          product.numberOfIngredients
        );
        return;
      }

      item.order_translations = {
        en: this.translateToOneLang("name", product, "en"),
        es: this.translateToOneLang("name", product, "es"),
        de: this.translateToOneLang("name", product, "de"),
        fr: this.translateToOneLang("name", product, "fr"),
        it: this.translateToOneLang("name", product, "it")
      };

      if (!this.isAdmin) {
        this.$store.commit("addToCart", { item: item, update: true });
        this.$store.dispatch("addStripeProductToCart", item);
      } else {
        item.cart_type = "admin";
        this.$store.commit("addToCart", { item: item, update: false });
        this.$store.dispatch("addStripeProductToCart", item);
      }

      this.$forceUpdate(); // Force update to fetch cart data (for displaying the new quantity)
    },
    closeQrValidationModal() {
      this.checkQR = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
